import type { IconComponentBaseProps } from 'components/atoms/Icon/types';

import { defaultTheme } from '@/theme';

type ExportNotesProps = IconComponentBaseProps;

export const ExportNotes = ({
  className,
  width = 24,
  height = 24,
  fill = defaultTheme.mantineColors.gray[6],
}: ExportNotesProps) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_10258_35969"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <rect width="24" height="24" fill="#9D5AD0" />
      </mask>
      <g mask="url(#mask0_10258_35969)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18 13.5518C19.2383 13.5518 20.2987 13.9931 21.1816 14.876C22.0645 15.7589 22.5068 16.8193 22.5068 18.0576C22.5068 19.296 22.0646 20.3573 21.1816 21.2402C20.2988 22.1229 19.2382 22.5645 18 22.5645C16.7618 22.5645 15.7012 22.1229 14.8184 21.2402C13.9354 20.3573 13.4932 19.296 13.4932 18.0576C13.4932 16.8193 13.9355 15.7589 14.8184 14.876C15.7013 13.9931 16.7617 13.5518 18 13.5518ZM17.8779 15.6348C17.7529 15.6346 17.6479 15.6763 17.5645 15.7598L15.5859 17.7383C15.501 17.8234 15.4581 17.9299 15.458 18.0576C15.458 18.1852 15.501 18.2918 15.5859 18.377L17.5645 20.3555C17.6479 20.4389 17.7528 20.4814 17.8779 20.4814C18.0029 20.4813 18.1072 20.4387 18.1904 20.3555C18.2737 20.2721 18.3153 20.1678 18.3154 20.043C18.3153 19.9181 18.2737 19.8138 18.1904 19.7305L16.958 18.498H20.2871C20.4104 18.498 20.5143 18.4576 20.5996 18.377C20.6848 18.2962 20.7277 18.19 20.7275 18.0576C20.7259 17.9329 20.6829 17.8285 20.5986 17.7441C20.5143 17.6598 20.4104 17.6172 20.2871 17.6172H16.958L18.1904 16.3857C18.2739 16.3023 18.3155 16.1973 18.3154 16.0723C18.3154 15.9473 18.2737 15.8431 18.1904 15.7598C18.1072 15.6765 18.0029 15.6349 17.8779 15.6348Z"
          fill={fill}
        />
        <path
          d="M18.6924 3.5C19.1895 3.50003 19.6148 3.67728 19.9688 4.03125C20.3227 4.38522 20.5 4.81051 20.5 5.30762V10.3652C20.5 10.5777 20.4279 10.7558 20.2842 10.8994C20.1404 11.0432 19.9624 11.1152 19.75 11.1152C19.5373 11.1152 19.3593 11.0432 19.2158 10.8994C19.0722 10.7557 19 10.5777 19 10.3652V5.30762C19 5.23067 18.9675 5.16064 18.9033 5.09668C18.8394 5.03255 18.7693 5.00004 18.6924 5H5.30762C5.23067 5.00004 5.16064 5.03255 5.09668 5.09668C5.03255 5.16064 5.00004 5.23067 5 5.30762V18.6924C5.00004 18.7693 5.03255 18.8394 5.09668 18.9033C5.16064 18.9675 5.23067 19 5.30762 19H10.3652C10.5777 19 10.7558 19.0721 10.8994 19.2158C11.0432 19.3596 11.1152 19.5376 11.1152 19.75C11.1152 19.9627 11.0432 20.1407 10.8994 20.2842C10.7557 20.4278 10.5777 20.5 10.3652 20.5H5.30762C4.81051 20.5 4.38522 20.3227 4.03125 19.9688C3.67728 19.6148 3.50003 19.1895 3.5 18.6924V5.30762C3.50003 4.81051 3.67728 4.38522 4.03125 4.03125C4.38522 3.67728 4.81051 3.50003 5.30762 3.5H18.6924Z"
          fill={fill}
        />
        <path
          d="M10.5176 15.1348C10.7298 15.1348 10.908 15.2063 11.0518 15.3496C11.1953 15.4932 11.2675 15.6715 11.2676 15.8838C11.2676 16.0965 11.1954 16.2753 11.0518 16.4189C10.908 16.5626 10.7299 16.6347 10.5176 16.6348H8C7.7875 16.6348 7.60949 16.5624 7.46582 16.4189C7.32207 16.2753 7.25 16.0972 7.25 15.8848C7.25005 15.6723 7.32213 15.4943 7.46582 15.3506C7.60949 15.2069 7.7875 15.1348 8 15.1348H10.5176Z"
          fill={fill}
        />
        <path
          d="M13.7402 11.25C13.9527 11.25 14.1307 11.3222 14.2744 11.4658C14.4182 11.6093 14.4902 11.7873 14.4902 12C14.4902 12.2124 14.4182 12.3904 14.2744 12.5342C14.1308 12.6779 13.9527 12.75 13.7402 12.75H8C7.7875 12.75 7.60949 12.6778 7.46582 12.5342C7.32207 12.3907 7.25 12.2126 7.25 12C7.25006 11.7876 7.32204 11.6096 7.46582 11.4658C7.60949 11.322 7.7875 11.25 8 11.25H13.7402Z"
          fill={fill}
        />
        <path
          d="M16 7.36523C16.2125 7.36523 16.3905 7.43755 16.5342 7.58105C16.6779 7.7247 16.75 7.90279 16.75 8.11523C16.7499 8.32773 16.6779 8.50566 16.5342 8.64941C16.3905 8.79308 16.2125 8.86523 16 8.86523H8C7.78761 8.86523 7.60945 8.79374 7.46582 8.65039C7.32209 8.50683 7.2501 8.32851 7.25 8.11621C7.25 7.90354 7.32199 7.72472 7.46582 7.58105C7.60946 7.43731 7.78757 7.36523 8 7.36523H16Z"
          fill={fill}
        />
      </g>
    </svg>
  );
};
